import { useSearchParams } from "react-router";

export default function useFields(): [
  number[] | null,
  (fieldIds: number[]) => void,
] {
  const [searchParams, setSearchParams] = useSearchParams();
  const fieldIdsParam = searchParams.get("fieldIds") || null;
  const setFieldIds = (fieldIds: number[]): void => {
    searchParams.set("fieldIds", fieldIds.join(","));
    setSearchParams(searchParams);
  };
  const parsedIds = fieldIdsParam
    ? fieldIdsParam
        .split(",")
        .map((fieldId: string) => parseInt(fieldId))
        .filter((id: number) => !isNaN(id))
    : [];
  return [parsedIds.length > 0 ? parsedIds : null, setFieldIds];
}
